/**
 * Created by rickborst on 21/02/2017.
 */

class User {

    /**
     * Constructs the model.
     *
     * @param {Object} [options] - Options object.
     */
    constructor (options = {}) {

        this.id = options.id || '';
        this.username = options.username || '';
        this.householdId = options.householdId || '';
        this.externalId = options.externalId || '';
        this.firstName = options.firstName || '';
        this.lastName = options.lastName || '';
        this.email = options.email || '';
        this.phone = options.phone || '';
        this.address = options.address || '';
        this.zip = options.zip || '';
        this.city = options.city || '';
        this.countryId = options.countryId || '';
        this.affiliateCode = options.affiliateCode || '';
        this.dynamicData = null;  // TODO: Research possible object shapes.
        this.facebookId = options.facebookId || '';
        this.facebookImage = options.facebookImage || '';
        this.facebookToken = options.facebookToken || '';
        this.isHouseholdMaster = options.isHouseholdMaster || '';
        this.objectType = options.objectType || '';
        this.suspensionState = options.suspensionState || '';
        this.userState = options.userState || '';
        this.userType = options.userType || null;
        this.apiSpecifics = options.apiSpecifics || {};
    }
}

export default User;


// WEBPACK FOOTER //
// ./src/js/models/user.js